/**
 * Google Integration Adapters
 *
 * Adapters implement IntegrationAdapter from ../adapter.ts
 * Each adapter is a plain object (no class hierarchy).
 *
 * Registration happens here — NOT in adapter files (Failure 5a prevention).
 * Adapter files export only the adapter object with no side-effect registrations.
 *
 * Implemented:
 * - Google Analytics 4 (Story 4.6)
 * - Google Search Console (Story 4.7)
 * - Google Ads (Story 4.8)
 * - YouTube Analytics (Story 4.9)
 * - Google Business Profile (Story 4.10)
 * - Google PageSpeed / Lighthouse (Story 4.11) — API-key auth, not OAuth
 */
import { ga4Adapter } from "./ga4";
import { gscAdapter } from "./gsc";
import { googleAdsAdapter } from "./google-ads";
import { youtubeAnalyticsAdapter } from "./youtube-analytics";
import { gbpAdapter } from "./gbp";
import { pagespeedAdapter } from "./pagespeed";
import { googleReviewsAdapter } from "./google-reviews";
import { registerAdapter } from "../registry";

// Google Analytics 4 (Story 4.6)
registerAdapter("google-analytics-4", ga4Adapter);

// Google Search Console (Story 4.7)
registerAdapter("google-search-console", gscAdapter);

// Google Ads (Story 4.8)
registerAdapter("google-ads", googleAdsAdapter);

// YouTube Analytics (Story 4.9)
registerAdapter("youtube-analytics", youtubeAnalyticsAdapter);

// Google Business Profile (Story 4.10)
registerAdapter("google-business-profile", gbpAdapter);

// Google PageSpeed / Lighthouse (Story 4.11) — API key, NOT OAuth
registerAdapter("google-pagespeed", pagespeedAdapter);

// Google Reviews (Story 23.1) — SIXTH Google-family OAuth platform.
// Shares Google OAuth family (NO new OAUTH_FAMILIES entry, NO new env keys).
registerAdapter("google-reviews", googleReviewsAdapter);
